import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {getPhoneRuleObj} from "@/plugins/vee-validate";

export default class CustomerLinkForm extends BaseModel {
  uuid = null;
  customer_uuid = null;
  to_customer_uuid = null;
  description = '';
  first_name = '';
  last_name = '';
  email = '';
  phone = '';
  description_text = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    description: 'required',
    email: 'email',
    phone: getPhoneRuleObj(),
  };

  attributeLabels = {
    to_customer_uuid: i18n.t('Customer'),
    description: i18n.t('Type'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    email: i18n.t('Email'),
    phone: i18n.t('Phone'),
    description_text: i18n.t('Other Type'),
  };

  getData() {
    return {
      to_customer_uuid: this.to_customer_uuid,
      description: this.description,
      customer_uuid: this.customer_uuid,
      uuid: this.uuid,
    }
  }

  toJSON() {
    let data = super.toJSON();

    if (data.description === 'Other (free text)') {
      data.description = data.description_text;
    }

    return data
  }
}
